export const userToString = (user) => `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();
